import { render, staticRenderFns } from "./selectRole.vue?vue&type=template&id=58fb5402&scoped=true&"
import script from "./selectRole.vue?vue&type=script&lang=js&"
export * from "./selectRole.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58fb5402",
  null
  
)

export default component.exports